/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setAddress} from '../api'

export const useMutationSetAddress = createReactQueryMutationHook('setAddress', setAddress)
